import React from "react";
import { Box, Modal, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import "./FeatureLockedModal.css";

const FeatureLockedModal = ({ open, onClose }) => {
  const handleContactUs = () => {
    onClose();
    window.open("https://nirantara.solutions/contact-us", "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: "15rem"
      }}
    >
      <Box className="modalBox">
        {/* Close button - positioned separately in top right */}
        <IconButton onClick={onClose} className="closeButton">
          <Close />
        </IconButton>

        {/* Title - centered */}
        <Box className="titleContainer">
          <p className="title">Feature Locked</p>
        </Box>

        <Box className="descriptionContainer">
          <p className="description">
            This feature is not available in the trial version.
            <br />
            To unlock access and explore full functionality, please contact us.
          </p>
        </Box>

        <Box className="buttonContainer">
          <button onClick={handleContactUs} className="contact-button">
            <span className="buttonText">Contact Us</span>
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FeatureLockedModal;
